import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'

export const CookingTimeText = ({
  recipe,
  numPortions,
}: {
  recipe: Recipe
  numPortions: number
}) => {
  if (!recipe.prepTime) {
    return null
  }

  return (
    <Box color={Color.ColdGrey_600}>
      {recipe.preparationType === 'heat-only' ? (
        <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1}>
          <Icon name="microwave" size={4} variant={IconVariant.Inherit} />
          <Text size={2} color={Color.Inherit}>
            {recipe.prepTime} mins (x{numPortions})
          </Text>
        </Box>
      ) : (
        <Text size={2} color={Color.Inherit}>
          {recipe.prepTime} mins
        </Text>
      )}
    </Box>
  )
}
